jQuery.feature_import("js-focus-onload",
  () => require("./focus-onload.js"),
  mod => mod.feature_js_focus_onload
);